export default __webpack_public_path__ + "media/images/images/raty/smiley/3-596f0aa8030a03da73603d449694b758.png";